import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { TypeTransactions } from 'src/app/core/api/models';
import { IncreaseUserCreditByIdCommand } from '../../../../core/api/models/increase-user-credit-by-id-command';
import { UsersService } from '../../../../core/api/services/users.service';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { ModalTitleComponent } from "../../../../shared/global/modal-title/modal-title.component";


@Component({
    selector: 'app-increase-user-credit-form',
    templateUrl: './increase-user-credit-form.component.html',
    styleUrls: ['./increase-user-credit-form.component.scss'],
    imports: [BaseFormModule, ModalTitleComponent]
})
export class IncreaseUserCreditForm
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  model: IncreaseUserCreditByIdCommand = {};

  userCredit: number;
  organizationCredit: number;

  get TypeTransactions() {
    return TypeTransactions;
  }

  //#endregion

  constructor(
    protected currentService: UsersService,

    private dialogRef: MatDialogRef<IncreaseUserCreditForm>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.model.userId = data.userId;
    this.userCredit = data.userCredit;
    this.organizationCredit = data.organizationCredit;
  }

  ngOnInit() {
    this.initForm();
    this.model.typeTransactions = TypeTransactions.Increase;
    this.formPageConfig.title = 'pages.users.increaseUserCreditTitle';
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  initForm() {
    this.form = new FormGroup({
      amount: new FormControl(Validators.required),
      typeTransactions: new FormControl(Validators.required),
      description: new FormControl(),
    });
  }

  //#region Api

  increaseUserCreditApi() {
    this.unSubs();

    this.loading = true;

    this.currentService
      .usersIncreaseUserCreditById({ body: this.model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  //#region events

  onChangeTypeTransactions() {
    if (this.model.typeTransactions === TypeTransactions.Increase)
      this.formPageConfig.title = 'pages.users.increaseUserCreditTitle';
    else this.formPageConfig.title = 'pages.users.decreaseUserCreditTitle';
  }

  onSubmit() {
    if (!this.isValidForm(this.form, this.tagName)) return;
    if (this.loading) return;
    this.increaseUserCreditApi();
  }

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }

  //#endregion
}
